import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ImboxImage from "../../assets/img/inbox-image.webp"
import PrimaryBtn from "./PrimaryBtn";

const GetTheBestTravelDeal = () => {
  const [email, setEmail] = useState("");

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const toastId = "email-error"; 

    if (!email) {
      if (!toast.isActive(toastId)) {
        toast.error("Email is required.", { toastId });
      }
    } else if (!validateEmail(email)) {
      if (!toast.isActive(toastId)) {
        toast.error("Please enter a valid email address.", { toastId });
      }
    } else {
      toast.dismiss(); 
      toast.success("Successfully subscribed!");
      console.log("Email submitted:", email);
      setEmail("");
    }
  };
  
  return (
    <div className="px-4 pb-[119px] max-xl:pb-20 max-lg:pb-16 max-md:pb-16">
      <div
        className="bg-no-repeat bg-center bg-cover h-[474px] max-lg:h-[380px] max-md:h-[350px] max-w-[1172px] mx-auto rounded-[20px] px-4 relative"
        style={{
          backgroundImage: `url(${ImboxImage})`,
        }}
      >
        <ToastContainer position="bottom-right" autoClose={3000} />
        <h2 className="max-w-[674px] mx-auto text-center text-[#fafafa] text-[58px] font-bold leading-[120%] pt-[131px] max-md:pt-20 max-xl:text-5xl max-lg:text-4xl max-md:text-3xl">
          Get the Best Travel Deals in Your Inbox
        </h2>
        <form
          onSubmit={handleSubmit}
          noValidate
          className="mt-6 flex justify-center items-center max-md:flex-col gap-[17px]"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="outline-none font-normal leading-[100%] text-base text-[#d9d9d9] placeholder:text-[#d9d9d9] placeholder:font-normal placeholder:leading-[100%] py-[17px] max-md:py-[14px] w-[276px] max-md:w-[250px] px-5 border-white/40 border bg-transparent rounded-[50px] inbox-input ff-sans"
            placeholder="Enter your email here"
          />
         <PrimaryBtn text="Subscribe" myClass=""/>
        </form>
      </div>
    </div>
  );
};

export default GetTheBestTravelDeal;
